// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2tPVg","requiredAsterisk":"Info_requiredAsterisk__ZmAni"};